import { Link } from 'react-router-dom';
import { Archive, BellRing, NotebookPen, ChevronRight, CircleUser, Database, FileText, HandCoins, Info, Salad, Settings, User } from 'lucide-react';
import { Page } from '../../components/Page';
import { useDbState } from '../../db/hooks';

const items = [
  { label: 'Account & plan', icon: CircleUser, to: '/more/account', accountOnly: true },
  { label: 'Doctor report', icon: FileText, to: '/more/report' },
  { label: 'Nutrition', icon: Salad, to: '/more/nutrition' },
  { label: 'Expenses', icon: HandCoins, to: '/more/expenses' },
  { label: 'Notes & questions', icon: NotebookPen, to: '/more/notes' },
  { label: 'Profile', icon: User, to: '/more/profile' },
  { label: 'Reminders', icon: BellRing, to: '/more/reminders' },
  { label: 'Export & import', icon: Archive, to: '/more/backup' },
  { label: 'Settings', icon: Settings, to: '/more/settings' },
  { label: 'About & disclaimer', icon: Info, to: '/more/about' },
  { label: 'Storage diagnostics', icon: Database, to: '/more/diagnostics' }
];

export function MorePage() {
  const state = useDbState();
  const demo = state.status === 'ready' && state.mode === 'demo';
  return (
    <Page title="More">
      <ul className="divide-y divide-clinical-line overflow-hidden rounded-xl border border-clinical-line bg-clinical-card">
        {items.filter((item) => !(demo && item.accountOnly)).map(({ label, icon: Icon, to }) => {
          const content = (
            <>
              <Icon className="h-5 w-5 text-clinical-primary" />
              <span className="flex-1">{label}</span>
              {to ? <ChevronRight className="h-4 w-4 text-clinical-muted" /> : <span className="text-xs text-clinical-muted">Soon</span>}
            </>
          );
          return (
            <li key={label}>
              {to ? (
                <Link to={to} className="focus-ring flex min-h-14 items-center gap-3 px-4 text-sm font-medium hover:bg-clinical-surface">
                  {content}
                </Link>
              ) : (
                <div className="flex min-h-14 items-center gap-3 px-4 text-sm font-medium text-clinical-muted">{content}</div>
              )}
            </li>
          );
        })}
      </ul>
    </Page>
  );
}
